import { createTheme } from "@mui/material";
import { colors } from "./colors";

export const TableThem = createTheme({
  palette: {
    primary: {
      main: colors.table_primary,
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Inter, sans-serif",
          fontSize: "14px",
          fontWeight: "580",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: "Inter, sans-serif",
          fontWeight: "400",
          color: colors.default_text,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          color: colors.default_text,
          height: "60px",
          ":hover": {
            backgroundColor: "#F7F7F7",
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          color: "#222222",
          "& .MuiTableCell-root": {
            color: "#222222",
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          color: colors.default_text,
          "&.Mui-selected": {
            color: "#fff",
          },
        },
        icon: {
          color: colors.gray_theme,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderBottomColor: "#fff",
          width: "100%",
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            color: colors.default_highlight,
            "& .MuiTableSortLabel-icon": {
              color: colors.default_highlight,
            },
          },
          fontWeight: "500",
        },
      },
    },
  },
});
